import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: React.ComponentType<{ className?: string }>;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  color?: 'tiber' | 'green' | 'red' | 'yellow';
}

const colorVariants = {
  tiber: 'bg-tiber-50 text-tiber-600 border-tiber-200',
  green: 'bg-atlantis-50 text-atlantis-600 border-atlantis-200',
  red: 'bg-red-50 text-red-600 border-red-200',
  yellow: 'bg-yellow-50 text-yellow-600 border-yellow-200',
};

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  icon: Icon,
  trend,
  color = 'tiber',
}) => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg border border-romance-200 p-6 hover:shadow-lg transition-shadow"
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-juridico/60 font-medium">{title}</p>
          <p className="text-3xl font-bold text-juridico mt-2">{value}</p>
          {trend && (
            <div className="flex items-center mt-2">
              <span
                className={`text-xs font-semibold ${
                  trend.isPositive ? 'text-atlantis-600' : 'text-red-600'
                }`}
              >
                {trend.isPositive ? '+' : ''}
                {trend.value}%
              </span>
              <span className="text-xs text-juridico/60 ml-1">{t('admin.statsCard.vsLastWeek')}</span>
            </div>
          )}
        </div>
        <div className={`p-4 rounded-full border-2 ${colorVariants[color]}`}>
          <Icon className="w-6 h-6" />
        </div>
      </div>
    </motion.div>
  );
};
